import React, {
  useEffect,
  useState
} from "react";

import { useNavigate } from "react-router-dom";


import { notify } from "../App";

const QuotationHistory = () => {
    const navigate = useNavigate();

  const [quotations, setQuotations] =
    useState([]);

  const [searchTerm, setSearchTerm] =
    useState("");

  useEffect(() => {

    fetchQuotations();

  }, []);

  const fetchQuotations =
    async () => {

      try {

        const res =
          await fetch(
            "/api/quotations"
          );

        const data =
          await res.json();

        setQuotations(
          Array.isArray(data)
            ? data
            : []
        );

      } catch (err) {

        console.log(err);

        setQuotations([]);

      }

    };

  const deleteQuotation =
    async (id) => {

      if (
        !window.confirm(
          "Delete quotation?"
        )
      ) {
        return;
      }

      try {

        const res =
          await fetch(
            `/api/quotations/${id}`,
            {
              method: "DELETE"
            }
          );

        const data =
          await res.json();

        if (data.success) {

          notify(
            "Quotation deleted",
            "success"
          );

          fetchQuotations();

        }

      } catch (err) {

        console.log(err);

      }

    };

  const filteredQuotations =
    quotations.filter(q =>

      (q.customer_name || "")
        .toLowerCase()
        .includes(
          searchTerm.toLowerCase()
        )

      ||

      (q.phone || "")
        .toLowerCase()
        .includes(
          searchTerm.toLowerCase()
        )

      ||

      String(q.id)
        .includes(searchTerm)

    );

  return (

    <div className="min-h-screen bg-[#F5F7FB] p-4 md:p-6 space-y-6">

      {/* HERO */}

      <div className="bg-gradient-to-r from-indigo-600 to-purple-600 rounded-3xl p-5 md:p-8 text-white shadow-xl">

        <div className="flex flex-col lg:flex-row justify-between lg:items-center gap-6">

          <div>

            <p className="uppercase tracking-widest text-indigo-200 text-sm">

              Quotation Management

            </p>

            <h1 className="text-2xl md:text-4xl font-bold mt-2">

              Quotations

            </h1>

            <p className="mt-3 text-indigo-100">

              Manage saved quotations
              and customer estimates.

            </p>

          </div>

          <div className="hidden md:flex flex-col items-end">

            <div className="bg-white/10 backdrop-blur-md px-6 py-4 rounded-2xl border border-white/20">

              <p className="text-sm text-indigo-100">

                Total Quotations

              </p>

              <h2 className="text-4xl font-bold mt-1">

                {quotations.length}

              </h2>

            </div>

          </div>

        </div>

      </div>

      {/* SEARCH */}

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">

        <div className="col-span-1 lg:col-span-8 bg-white rounded-3xl p-5 shadow-sm border border-gray-100">

          <div className="flex items-center gap-4">

            <div className="w-12 h-12 rounded-2xl bg-indigo-100 flex items-center justify-center text-xl">

              🔍

            </div>

            <input
              type="text"
              placeholder="Search quotation..."
              value={searchTerm}
              onChange={(e) =>
                setSearchTerm(
                  e.target.value
                )
              }
              className="w-full border border-gray-200 bg-gray-50 rounded-2xl px-5 py-4 outline-none"
            />

          </div>

        </div>

        <div className="col-span-1 lg:col-span-4 bg-white rounded-3xl p-5 md:p-6 shadow-sm border border-gray-100">

          <div className="flex flex-col lg:flex-row justify-between lg:items-center gap-6">

            <div>

              <p className="text-sm text-gray-500">

                Filtered Results

              </p>

              <h2 className="text-3xl md:text-4xl font-bold text-indigo-600 mt-3">

                {
                  filteredQuotations.length
                }

              </h2>

            </div>

            <div className="w-16 h-16 rounded-2xl bg-indigo-100 flex items-center justify-center text-3xl">

              📄

            </div>

          </div>

        </div>

      </div>

      {/* TABLE */}

      <div className="bg-white rounded-3xl shadow-sm border border-gray-100 overflow-hidden">

       <div className="px-5 md:px-8 py-6 border-b border-gray-100 flex flex-col sm:flex-row justify-between sm:items-center gap-4">

  <div>

    <h2 className="text-2xl font-bold text-gray-800">
      Quotation Directory
    </h2>

    <p className="text-sm text-gray-500 mt-1">
      Saved customer quotations
    </p>

  </div>

</div>

        <div className="overflow-x-auto">

          <table className="min-w-[850px] w-full">

            <thead className="bg-gray-50">

              <tr>

                <th className="text-left px-8 py-5">
                  ID
                </th>

                <th className="text-left px-6 py-5">
                  Customer
                </th>

                <th className="text-left px-6 py-5">
                  Phone
                </th>

                <th className="text-left px-6 py-5">
                  Grand Total
                </th>

                <th className="text-left px-6 py-5">
                  Date
                </th>

                <th className="text-right px-8 py-5">
                  Actions
                </th>

              </tr>

            </thead>

            <tbody>

              {filteredQuotations.map(q => (

                <tr
                  key={q.id}
                  className="border-t border-gray-100 hover:bg-gray-50"
                >

                  <td className="px-8 py-6">

                    #{q.id}

                  </td>

                  <td className="px-6 py-6">

                    {q.customer_name}

                  </td>

                  <td className="px-6 py-6">

                    {q.phone}

                  </td>

                  <td className="px-6 py-6 font-semibold text-indigo-600">

                    ₹{q.grand_total}

                  </td>

                  <td className="px-6 py-6">

                    {
                      new Date(
                        q.created_at
                      ).toLocaleDateString()
                    }

                  </td>

                  <td className="px-8 py-6 text-right whitespace-nowrap">

                   <button
  onClick={() =>
    navigate(`/quotation/${q.id}`)
  }
  className="whitespace-nowrap bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-4 py-2 rounded-xl mr-2"
>
  View
</button>

                    <button
                      onClick={() =>
                        deleteQuotation(
                          q.id
                        )
                      }
                    className="whitespace-nowrap bg-red-500 text-white px-4 py-2 rounded-xl"
                    >

                      Delete

                    </button>

                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>

      </div>

    </div>

  );

};

export default QuotationHistory;